import { Report } from '@modules/report/models/report.model';

export class ReportMapper {
  public mapReportRequest(data: Report) {
    const request = {
      UId: data.uId,
      TaskId: data.taskId,
      LongDesc: data.longDesc,
      ItemsDiff: data.itemsDiff,
      SignLocation: data.signLocation,
      SignDate: data.signDate ? new Date(String(data.signDate)) : undefined,
      MediaId: data.mediaId,
      Title: data.title,
      Header: data.header,
      PreText: data.preText,
      PostText: data.postText,
      Footer: data.footer,
    };

    return request;
  }
}
